import { minusOnePx as minusOnePxFunc } from "../utils/minusOnePx.js";
import { useMedia } from "./useMedia/index.js";
import { useTheme } from "./useTheme.js";
export const useBreakpoint = ({ minusOnePx = false, } = {}) => {
    const { breakpoints } = useTheme();
    const mobileBp = minusOnePx
        ? minusOnePxFunc(breakpoints.md, true)
        : breakpoints.md;
    const desktopBp = minusOnePx
        ? minusOnePxFunc(breakpoints.lg, true)
        : breakpoints.lg;
    const isMobile = !!useMedia([`(max-width: ${mobileBp})`], [true]);
    const isDesktop = !!useMedia([`(max-width: ${desktopBp})`], [true]);
    return {
        isMobile,
        isDesktop,
    };
};
//# sourceMappingURL=useBreakpoint.js.map